import { render, staticRenderFns } from "./MultipleSpecs.vue?vue&type=template&id=1acde73d&scoped=true"
import script from "./MultipleSpecs.vue?vue&type=script&lang=js"
export * from "./MultipleSpecs.vue?vue&type=script&lang=js"
import "./MultipleSpecs.vue?vue&type=style&index=0&id=1acde73d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acde73d",
  null
  
)

export default component.exports